<template>
  <div class="side-container menu-bd" :class="{ 'hide-sidebar': hideside }">
    <div class="logo ub ub-xc">
      <div class="ub-f1" v-if="!hideside">
        <img src="../images/layout/menu_logo.svg" alt />
      </div>
      <div class="side" @click="toggleLeftMenu">
        <i v-if="hideside" class="icon icon-cebianlanzhankai"></i>
        <i v-else class="icon icon-cebianlanguanbi"></i>
      </div>
    </div>
    <div class="app">
      <h1 v-if="!hideside && !isShow">{{ appName }}</h1>
      <i class="centerY icon icon-menu" v-if="!isShow" @click="isShow = !isShow"></i>
      <i class="centerY icon icon-fanhuijiantou" v-else @click="isShow = !isShow"></i>
    </div>
    <!-- 菜单 -->
    <div class="wrap">
      <!-- <el-scrollbar style="height: 100%" ref="scrollbar"> -->
      <ul class="app-list ubv ub-ac" v-if="isShow" :style="{ 'padding-top': paddingTop + 'px' }">
        <li @click="onApp(item)" v-for="(item, index) in appList" :key="index" :class="{ cur: appId === item.appId }">
          <div class="icon-box">
            <i :class="'icon icon-' + item.appCode"></i>
          </div>
          <h1 v-if="!hideside">{{ item.appName }}</h1>
        </li>
      </ul>
      <div v-else>
        <el-menu
          :class="{ open: !hideside }"
          :collapse="hideside"
          :unique-opened="true"
          :default-active="$route.query.parentPath || $route.path"
          text-color="rgba(255,255,255, 0.85)"
          background-color="transparent"
        >
          <template v-for="item in appMenu">
            <!-- 只有一级菜单 -->
            <el-menu-item :index="item.loadRes" :key="item.menuId" v-if="!item.children || item.children[0]['showWay'] === 4" @click.native="onMenuLink(item)">
              <div class="line1">
                <i class="menu-icon icon" :class="item.menuIcon"></i>
                <span class="menu-name" :title="item.menuName">{{ item.menuName }}</span>
              </div>
            </el-menu-item>
            <!--包含二级菜单-->
            <el-submenu :index="item.loadRes" :key="item.menuId" v-else>
              <template slot="title">
                <div class="line1">
                  <i class="menu-icon icon" :class="item.menuIcon"></i>
                  <span class="menu-name" :title="item.menuName">{{ item.menuName }}</span>
                </div>
              </template>
              <el-menu-item :key="value.menuId" :index="value.loadRes" v-for="value in item.children" @click.native="onMenuLink(value)">
                <div class="line1">
                  <i class="menu-icon icon" :class="value.menuIcon"></i>
                  <span class="menu-name" :title="value.menuName">{{ value.menuName }}</span>
                </div>
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </div>
      <!-- </el-scrollbar> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // 应用列表
    appList: {
      type: Array,
      default() {
        return [];
      },
    },
    // 是否隐藏侧边栏
    hideside: {
      type: Boolean,
      default: false,
    },
    appId: {
      type: String,
      default: '',
    },
    // 菜单列表
    appMenu: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      isShow: false,
      parentPath: '',
      pageH: document.documentElement.clientHeight,
      liH: 130,
      baseTop: 130,
      sizeChangeHandler: null,
    };
  },
  watch: {
    // isShow() {
    //   this.updateScrollbar();
    // },
  },
  computed: {
    appName: (vm) => {
      const app = vm.appList.find(t => t.appId === vm.appId) || {};
      return app.appName;
    },
    paddingTop() {
      const len = this.appList.length;
      const ret = (this.pageH - this.liH * len) / 2 - this.baseTop;
      return Math.max(ret, 0);
    },
  },
  mounted: function () {
    this.sizeChangeHandler = this.$debounce(() => {
      this.updatePageH();
    }, 300);
    window.addEventListener('resize', this.sizeChangeHandler, false);
  },
  methods: {
    updatePageH() {
      this.pageH = document.documentElement.clientHeight;
      // this.updateScrollbar();
    },
    // updateScrollbar() {
    //   this.$nextTick(this.$refs.scrollbar.update);
    // },
    // 切换应用
    onApp: function (item) {
      this.isShow = false;
      this.$emit('change', item);
    },
    // 侧边目录显示影藏
    toggleLeftMenu: function () {
      const hideSide = this.$store.state.vm.hideSide;
      this.$store.commit('HIDESIDE', !hideSide);
    },
    // 点击跳转
    onMenuLink: function (value) {
      // const keep = this.$route.meta && this.$route.meta.keep;
      // if (keep) {
      //   this.clearKeepAlive(keep);
      // }
      // this.$nextTick(() => {
      //   this.$router.replace({
      //     path: `/redirect${value.loadRes}`,
      //   });
      // });
      // console.log(this.$router.getRoutes({ path: '/company/department' }));

      // const includeList = this.$store.state.vm.includeList;

      // const includes = includeList.filter(t => t !== componentName);
      // this.$store.commit('INCLUDELIST', includes);

      this.$router.push(`/redirect${value.loadRes}`, () => {});
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.sizeChangeHandler, false);
  },
};
</script>
<style lang="scss">
@import '@/style/mixin.scss';

.el-menu--vertical {
  background-color: #404040;
}

.side-container {
  font-family: 'Helvetica Neue', 'Luxi Sans', 'DejaVu Sans', Tahoma, 'Hiragino Sans GB', STHeiti, 'Microsoft YaHei', sans-serif;
  @include background_menu();
  width: 200px;
  height: 100%;
  font-size: 0;
  overflow: hidden;
  transition: width 0.28s;
  -webkit-transition: width 0.28s;
  display: flex;
  flex-direction: column;

  ::-webkit-scrollbar-track {
    background: #0d9ae0;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: rgba(0, 0, 0, 0.1);
  }

  &.hide-sidebar {
    width: 50px;
    .logo .side {
      padding: 14px 17px;
    }
    .app .icon {
      left: 18px;
      right: auto;
    }
    .el-submenu__title {
      padding-left: 18px !important;
    }
    .el-menu-item {
      padding-left: 18px !important;
    }
    .app-list li {
      padding-top: 32px;
      height: 90px;
    }
    .app-list li .icon {
      font-size: 24px;
    }
  }
  .logo {
    height: 50px;
    .ub-f1 {
      padding-left: 15px;
      img {
        display: block;
        width: 118px;
        height: 50px;
      }
    }
    .side {
      padding-right: 20px;
      padding-top: 4px;
      font-size: 0;
      .icon {
        color: #e4ebe8;
        font-size: 16px;
      }
    }
  }
  .app {
    line-height: 80px;
    height: 80px;
    color: #ffffff;
    font-size: 14px;
    position: relative;
    h1 {
      color: rgba(255, 255, 255, 0.85);
      font-size: 12px;
      padding-left: 20px;
    }
    .icon {
      cursor: pointer;
      right: 22px;
      color: rgba(255, 255, 255, 0.85);
      font-size: 12px;
    }
  }
  .app-list {
    // height: 100%;
    // padding-top: 70px;
    li {
      height: 130px;
      text-align: center;
      padding-top: 30px;
      flex-shrink: 0;

      &.cur {
        background: rgba(0, 0, 0, 0.12);
      }
      cursor: pointer;
      .icon {
        font-size: 46px;
        color: #ffffff;
      }
      h1 {
        font-size: 12px;
        color: #ffffff;
        line-height: 30px;
        margin-top: 6px;
      }
    }
  }
  .wrap {
    flex: 1;
    height: 0;
    overflow-y: auto;
    .side {
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-top: 1px solid #36353b;
      border-bottom: 1px solid #36353b;
      .icon {
        cursor: pointer;
        font-size: 18px;
        color: rgba(255, 255, 255, 0.4);
      }
    }
  }
  .el-menu .line1 {
    font-size: 0;
    line-height: 40px;
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    .menu-name {
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 12px;
    }
    .menu-icon {
      font-size: 14px;
      color: #ffffff;
      margin-right: 10px;
      flex-shrink: 0;
    }
  }
  /*样式重写*/
  .el-menu {
    border-right: none;
  }
  .el-menu .el-submenu__icon-arrow {
    color: #ffffff;
  }
  .el-menu .el-menu-item {
    height: 40px;
    line-height: 40px;
    transition: all 0.28s;
    -webkit-transition: all 0.28s;
    &.is-active {
      color: #ffffff;
      background-color: rgba(0, 0, 0, 0.12) !important;
    }
  }
  .el-menu .el-submenu__title {
    height: 40px;
    line-height: 40px;
    transition: all 0.28s;
    -webkit-transition: all 0.28s;
  }
  .el-menu .el-submenu__icon-arrow {
    right: 25px;
  }
  .el-menu .el-submenu__title:hover {
    background: rgba(0, 0, 0, 0.12) !important;
  }
  .el-menu .el-menu-item:hover {
    background: rgba(0, 0, 0, 0.12) !important;
  }
  .el-menu .is-active.el-menu-item:hover {
    background: rgba(0, 0, 0, 0.12) !important;
  }
  .el-menu .el-submenu .el-menu-item {
    padding: 0;
    min-width: 0;
    padding-left: 50px !important;
  }
}
</style>
